import { useContext, useEffect, useState } from "react";

import "../PPMContent/PPMContent.scss";
import "./CorporateGovernancePolicy.scss";
import "../SafeAggrement/SafeAggrement.scss";
import parser from "html-react-parser";
import { Context } from "../../contextApi/contextProvider";
import { cmsPublicContent } from "../../utils/cmscontent/cms";
import { MarkDocumentRead } from "../../utils/Api/api";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";

const InvestorRelationsPolicy = () => {
  const loaction = useGeoLocation();
  const { userLoginData } = useContext(Context);

  const [htmlStr, setHtmlStr] = useState<any>([]);
  const contents = [
    "1. PURPOSE",
    "2. SCOPE",
    "3. CORE PRINCIPLES",
    "4. GOVERNANCE & RESPONSIBILITIES",
    "5. COMMUNICATION FRAMEWORK",
    "6. INVESTOR PORTAL & DATA ROOM STRUCTURE",
    "7. DISCLOSURE POLICY",
    "8. INVESTOR LIFECYCLE MANAGEMENT",
    "9. INVESTOR REPORTING",
    "10. COMPLIANCE & LEGAL STANDARDS",
    "11. CONFIDENTIALITY & DATA PROTECTION",
    "12. CONFLICT OF INTEREST",
    "13. RECORD KEEPING & AUDIT",
    "14. ENFORCEMENT",
    "15. REVIEW ",
    "16. CONTACT",
    "17. ACKNOWLEDGMENT",
  ];
  useEffect(() => {
    readDoc();
    document.title = "TICCA | Investor Relations Policy";
  }, [userLoginData.status]);
  const fetchCmsContent = async () => {
    const response = await cmsPublicContent({
      post_id: "15509",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
    fetchCmsContent();

    document.title = "TICCA | Investor Relations Policy";
    window.scrollTo(0, 0);
  }, []);

  const readDoc = async () => {
    if (userLoginData.status === 200) {
      try {
        const { data } = await MarkDocumentRead({
          ip_address: await userLoginData.ip,
          latitude: loaction.coordinates?.lat ?? "0.0",
          longitude: loaction.coordinates?.lng ?? "0.0",
          post_id: "6278",
        });
      } catch (error) {}
    }
  };
  return (
    <>
      {htmlStr.length && (
        <div className="watermaring-main-dev">
          <img
            src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
            alt="logo"
          />
          <p>
            Commercial in Confidence <br />
            Content under NDA.
            <br /> {userLoginData?.email}
          </p>
        </div>
      )}
      {htmlStr.length <= 2 && (
        <div
          style={{ marginTop: "100px" }}
          className=" page-shimmer-container-co"
        >
          {Array.from({ length: 20 }).map((_, index) => (
            <div className="page-shimmer-co" key={index}></div>
          ))}
        </div>
      )}
      {htmlStr.length > 2 && (
        <div style={{ marginTop: "100px" }} className="shareholder-main-dev">
          <div className="safe-agreement-container">
            {/* Header */}
            <div className="header">
              <p className="cor-title">Investor Relations Policy</p>
            </div>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>TABLE OF CONTENTS</h2>
              <ul>
                {contents.map((item, index) => (
                  <li key={index}>
                    <div className="line">
                      <span className="title">{item}</span>
                      <span className="dots"></span>
                      <span className="page-number">{3 + index}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="safe-agreement-container">
            {htmlStr.length > 1 &&
              htmlStr.map((elem: any, index: number) => (
                <div
                  key={`table-of-contentsr-${index}`}
                  className="safe-agreement-cms-container"
                >
                  {parser(elem)}
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default InvestorRelationsPolicy;
